export default "__VITE_ASSET__BrsOfiMN__"